import { PlatformStatisticsDto } from 'api/Trading-Accounts/Types/PlatformStatisticsDto'
import { PlatformStatisticsKey } from 'store/transactions/transaction.types'

export const normalizeStatistics = (data: PlatformStatisticsDto[]): PlatformStatisticsDto[] =>
  data.map((statistic: PlatformStatisticsDto) => ({
    ...statistic,
    [PlatformStatisticsKey.CURRENCY]: statistic?.currency?.id,
    [PlatformStatisticsKey.ACCOUNT_GROUP]: statistic?.accountGroup?.name,
    [PlatformStatisticsKey.PLATFORM_TYPE]: statistic?.platformType?.name,
    [PlatformStatisticsKey.STATUS]: statistic?.status?.name,
  }))
